import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-content/fleche-passer-au-suivant-blanc.png'


const _withScopeId = n => (_pushScopeId("data-v-3eca02b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "back-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "middle-buttons-container" }
const _hoisted_7 = { class: "end-buttons-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "image-container",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($props.onBack && $props.onBack(...args)))
        }, _hoisted_5)
      ]),
      _createElementVNode("h1", null, _toDisplayString($props.title), 1),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "subHeader", {}, undefined, true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "middleButtons", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "endButtons", {}, undefined, true)
    ])
  ]))
}